export const createUserFullName = (firstName: string, lastName: string) => [firstName, lastName].join(' ').trim();
